export default __webpack_public_path__ + "93eae10.png";